import { Sparkles, Swords, Wallet } from "lucide-react";

export const USER_DETAIL_TABS = [
  { id: "p2p", label: "P2P", hint: "Duels", icon: Swords },
  { id: "predictions", label: "Tips", hint: "Community", icon: Sparkles },
  { id: "transaction", label: "Ledger", hint: "Money", icon: Wallet },
];

export function getUserDetailTab(id) {
  return USER_DETAIL_TABS.find((tab) => tab.id === id) || USER_DETAIL_TABS[0];
}

export const USER_TAB_ICONS = Object.fromEntries(
  USER_DETAIL_TABS.map((tab) => [tab.id, tab.icon])
);
